import React from 'react';

const SIZES = {
  sm: { mark: 'h-7 w-7', text: 'text-base', tagline: 'text-[9px]' },
  md: { mark: 'h-9 w-9', text: 'text-lg', tagline: 'text-[10px]' },
  lg: { mark: 'h-11 w-11', text: 'text-xl sm:text-2xl', tagline: 'text-[11px]' },
};

/** The brand lockup: shield mark + wordmark, drawn as text so it stays crisp at any size.
 *  tone="dark" is for dark backgrounds. */
export const Logo = ({ tone = 'light', size = 'md', withTagline = false, className = '' }) => {
  const s = SIZES[size] || SIZES.md;
  const dark = tone === 'dark';

  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <picture>
        <source srcSet="/logo-mark.webp" type="image/webp" />
        <img
          src="/logo-mark.png"
          width="96"
          height="96"
          alt=""
          aria-hidden="true"
          className={`${s.mark} shrink-0 rounded-lg object-contain`}
        />
      </picture>
      <span className="flex flex-col leading-none" aria-hidden="true">
        <span
          className={`${s.text} font-bold tracking-tight ${dark ? 'text-white' : 'text-slate-900'}`}
          style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}
        >
          Verif<span className={dark ? 'text-blue-400' : 'text-blue-600'}>A</span>Eye
        </span>
        {withTagline && (
          <span
            className={`${s.tagline} mt-1 font-medium uppercase tracking-[0.16em] ${
              dark ? 'text-slate-400' : 'text-slate-500'
            }`}
          >
            The proof is in the detail
          </span>
        )}
      </span>
      <span className="sr-only">VerifAEye</span>
    </span>
  );
};

export default Logo;
